import {fetchConstructionData, getConstructionUsers} from "./useConstruction";

export default {
    data() {
        return {
            construction_list: [],
            construction_info: {},
        };
    },
    computed: {
        fuze_users() {
            return getConstructionUsers(this.construction_list, this.ruleForm?.construction_unit);
        }
    },
    methods: {
        //获取建设单位
        async GetConstruction() {
            this.construction_list = [];
            this.construction_info = {};
            let {constructionList, constructionInfo} = await fetchConstructionData();
            this.construction_list = constructionList;
            this.construction_info = constructionInfo;
        },
    }
};
